export default {
  tableCanslim: {
    TICKER: 'MÃ',
    MARKET_CAP: 'VỐN HÓA <br>(Tỷ)</br>',
    CURRENT_EARNING: 'LỢI NHUẬN <br>HIỆN TẠI</br>',
    ANNUAL_EARNING: 'LỢI NHUẬN <br>HẰNG NĂM</br>',
    NEW_PRODUCT: 'YẾU TỐ<br>MỚI</br>',
    SUPPLY_AND_DEMAND: 'CUNG&<br>CẦU</br>',
    LEADER_AND_LARGARD: 'DẪN ĐẦU&<br>ĐI SAU</br>',
    INSTITUTIONAL_SPONSORSHIP: 'QUỸ &<br>TỔ CHỨC ĐẦU TƯ</br>',
    MARKET_DIRECTION: 'XU HƯỚNG <br>THỊ TRƯỜNG</br>',
    TOTAL: 'TỔNG ĐIỂM',
  },
  title: 'CANSLIM',
  firstStrName: "Chiến lược CANSLIM của William O'Neil",
  secondStrName: 'Chiên lược đầu từ cổ phiếu tăng trưởng được sử dụng phổ biến',
};
